<template>
  <loader :is-loading="isLoading" progress-class="mt-4">
    <v-card class="background" elevation="0">
      <v-card-title>
        <v-row justify="space-between">
          <v-col cols="12">
            <v-tabs background-color="background" v-model="graph">
              <v-tab>
                {{ generateMessage('properties_360.readings.general') }}
              </v-tab>
              <v-tab>
                {{ generateMessage('properties_360.readings.chauffage') }}
              </v-tab>
              <v-tab v-show="hasECS">
                {{ generateMessage('properties_360.readings.ecs') }}
              </v-tab>
              <v-tab>
                {{ generateMessage('properties_360.readings.signature') }}
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-tabs-items v-model="graph">
          <v-tab-item>
            <readings-results-general
              :dataIn="resultSet"
              :dataInCumulated="resultSetCumulated"
              :dataInLogbook="resultSetLogbook"
              :market="currentFormula"
              :baseTemperature="baseTemperature"
              :displayed="graph === 0"
            />
          </v-tab-item>
          <v-tab-item>
            <readings-heating-by-month
              :resultSetByMonth="resultSetByMonth"
              :graph="1"
              :displayed="graph === 1"
            />
          </v-tab-item>
          <v-tab-item v-show="hasECS">
            <readings-ecs-by-month
              :resultSet="resultSet"
              :resultSetCumulated="resultSetCumulated"
              :resultSetByMonth="resultSetByMonth"
              :graph="2"
              :displayed="graph === 2"
            />
          </v-tab-item>
          <v-tab-item>
            <readings-signature
              :dataIn="resultSet"
              :market="currentFormula"
              :baseTemperature="baseTemperature"
              :properties_360="properties360"
              :displayed="graph === 3"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </loader>
</template>

<script>
import EnergyMeteringService from '@/services/services/energyMetering.service';
import { mapGetters } from 'vuex';
import Loader from '@/components/widgets/Loader';
import ReadingsResultsGeneral from '@/pages/FRI/readings/ReadingsResultsGeneral';
import ReadingsHeatingByMonth from '@/pages/FRI/readings/ReadingsHeatingByMonth';
import ReadingsEcsByMonth from '@/pages/FRI/readings/ReadingsEcsByMonth';
import ReadingsSignature from '@/pages/FRI/readings/ReadingsSignature';
import { generateMessage } from '@/utils/i18n';
import { showColor } from './ReadingsUtils';

export default {
  name: 'SummaryPropertyReadings',
  components: {
    Loader,
    ReadingsResultsGeneral,
    ReadingsHeatingByMonth,
    ReadingsEcsByMonth,
    ReadingsSignature,
  },
  props: {
    propertyId: { type: Number, required: true },
  },
  data() {
    return {
      isLoading: false,
      baseTemperature: 18,
      graph: -1,
      data: [],
      hasECS: true,
      resultSet: [],
      resultSetCumulated: [],
      resultSetByMonth: [],
      resultSetLogbook: [],
    };
  },
  computed: {
    ...mapGetters({
      properties360: 'properties_360/current',
    }),
    currentFormula() {
      const market = this.properties360.market_type;
      return market === 'MC' || market === 'MCI' ? market : 'F';
    },
  },
  methods: {
    showColor,
    generateMessage,
  },
  watch: {
    resultSet() {
      this.noData = !this.resultSet.length;
    },
    propertyId: {
      handler(val) {
        this.isLoading = true;
        const baseUrlApi = `${process.env.MYPREDITY_BASE_URI}/properties_results/${val}`;
        const baseUrlLogbook = `${process.env.MYPREDITY_BASE_URI}/logbook/properties/${val}`;

        const getResults = EnergyMeteringService.getItems({}, baseUrlApi).then(
          (res) => {
            this.resultSet = res;
            this.hasECS = !(
              this.resultSet.length && this.resultSet[0].ecs_m3 === null
            );
            this.data = this.resultSet;
          }
        );

        const getCumulated = EnergyMeteringService.getItems(
          {},
          `${baseUrlApi}/cumulated`
        ).then((res) => {
          this.resultSetCumulated = res;
        });

        const getMonthly = EnergyMeteringService.getItems(
          {},
          `${baseUrlApi}/monthly`
        ).then((res) => {
          this.resultSetByMonth = res;
        });

        const getLogbook = EnergyMeteringService.getItems(
          {},
          `${baseUrlLogbook}`
        ).then((res) => {
          this.resultSetLogbook = res;
        });

        Promise.all([getResults, getCumulated, getMonthly, getLogbook]).finally(
          () => {
            this.isLoading = false;
          }
        );
      },
      immediate: true,
    },
  },
};
</script>
